import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  Box,
  Button,
  FormControl,
  Modal,
  TextareaAutosize,
} from "@material-ui/core";

import { ModalHeader } from "../../ModalHeader";

import { useStyles } from "../../../Styles/styles";
import { useCookies } from "react-cookie";

const NarrativeSegmentEditModal = ({
  open,
  segment,
  onSave,
  onClose,
  userId,
}) => {
  const classes = useStyles();

  const [editValue, setEditValue] = useState();
  const [cookies] = useCookies();

  useEffect(() => {
    if (segment) {
      setEditValue(segment.content);
    }
  }, [segment]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      keepMounted={false}
      style={{ width: "90vw", margin: "auto" }}
      data-testid="narrative-segment-edit-modal"
    >
      <div
        id={"narrative-segment-edit-wrapper"}
        data-testid={"narrative-segment-edit-wrapper"}
        style={{
          height: "fit-content",
          width: "fit-content",
          borderRadius: "5px",
        }}
        className={classes.tabRoot}
      >
        <ModalHeader
          headerName={"Narrative Edit"}
          setModalOpen={onClose}
          nightMode={cookies[`mp-userId-${userId}-night-mode`] === "true"}
          helpIconObjectName={""}
        />
        <div style={{ padding: "5px" }}>
          <FormControl fullWidth>
            <TextareaAutosize
              data-testid="narrative-segment-edit-textarea"
              onChange={e => setEditValue(e.target.value)}
              className={
                cookies[`mp-userId-${userId}-night-mode`] === "true"
                  ? classes.textAreaDark
                  : classes.textAreaLight
              }
              margin="dense"
              id="newNarrative-id"
              value={editValue}
              name="newNarrative"
            />
          </FormControl>
          <Box display="flex" flexDirection="row">
            <Button
              style={{
                width: "fit-content",
                marginTop: "1vh",
                marginBottom: "3vh",
                marginRight: "2vw",
              }}
              variant="contained"
              onClick={() => onSave(editValue.trim())}
              data-testid="narrative-segment-edit-submit-button"
            >
              Submit
            </Button>
            <Button
              style={{
                width: "fit-content",
                marginTop: "1vh",
                marginBottom: "3vh",
              }}
              variant="contained"
              onClick={onClose}
              data-testid="narrative-segment-edit-cancel-button"
            >
              Cancel
            </Button>
          </Box>
        </div>
      </div>
    </Modal>
  );
};

NarrativeSegmentEditModal.propTypes = {
  open: PropTypes.bool.isRequired,
  segment: PropTypes.shape({
    content: PropTypes.string.isRequired,
  }),
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default NarrativeSegmentEditModal;
